import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deliveredOrder,
  getNewOrders,
  getOrders,
  placeOrder,
  returnCompletedOrder,
  returnPickedUpOrder,
  shipOrder,
  updateOrderDeliveryDate
} from "../../State/Order/Action";
import {
  Button,
  Card,
  CardHeader,
  Menu,
  MenuItem,
  Paper,
  Modal,
  Box,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  DialogContentText,
  CardContent,
  Chip,
  Tooltip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { FileDownload, PictureAsPdf, Print, Visibility } from "@mui/icons-material";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DataGrid } from "@mui/x-data-grid";
import ImagePopup from "../../../Common/ImagePopup";
import defaultImage from "../../../Common/productDefaultImage.png"

const Orders = () => {
  const dispatch = useDispatch();
  const { employeeOrders } = useSelector((store) => store);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [openDateHistoryModal, setOpenDateHistoryModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [region, setRegion] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedStatusOrderId, setSelectedStatusOrderId] = useState(null);
  const [order, setOrder] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [searchText, setSearchText] = useState("");
  const [openCalendars, setOpenCalendars] = useState({});
  const [imageOpen, setImageOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  const toggleCalendar = (index, orderId, forceClose = false) => {
    setSelectedOrderId(orderId);
    setOpenCalendars((prev) => ({
      ...prev,
      [index]: forceClose ? false : !prev[index]
    }));
  };

  useEffect(() => {
    dispatch(getOrders());
    dispatch(getNewOrders());
  }, [dispatch, employeeOrders.changedDate]);

  const handleMenuClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedIndex(null);
  };

  const handleOrderStatusChange = (orderId, action) => {
    switch (action) {
      case "ACCEPT":
        dispatch(placeOrder(orderId));
        break;
      case "SHIPPED":
        dispatch(shipOrder(orderId));
        break;
      case "DELIVERED":
        dispatch(deliveredOrder(orderId));
        break;
      case "PICKED_UP":
        dispatch(returnPickedUpOrder(orderId));
        break;
      case "COMPLETED":
        dispatch(returnCompletedOrder(orderId));
        break;
      default:
        break;
    }
  };

  const handleDateChange = (newDate, orderId, region) => {
    const data = { deliveryDate: newDate.format("YYYY-MM-DD"), region: region };
    if (newDate && dayjs(newDate).isValid() && region) {
      dispatch(updateOrderDeliveryDate(orderId, data));
    }
    setRegion("");
    setSelectedDate(null);
    setSelectedOrderId(null);
  };

  const handleConfirmOpen = (orderId, status) => {
    setSelectedStatusOrderId(orderId);
    setSelectedStatus(status);
    setConfirmOpen(true);
    handleMenuClose();
  };

  const handleStatusChange = () => {
    if (selectedStatusOrderId && selectedStatus) {
      handleOrderStatusChange(selectedStatusOrderId, selectedStatus);
    }
    setConfirmOpen(false);
    setSelectedStatusOrderId(null);
    setSelectedStatus("");
  };

  const getStatusChip = (status) => {
    const colorMap = {
      "PENDING": "warning",
      "ORDER ACCEPT": "dark",
      "SHIPPED": "info",
      "DELIVERED": "success",
      "CANCELLED": "error",
      "RETURNED": "error",
      "PICKED_UP": "dark",
      "COMPLETED": "success"
    };
    return <Chip label={status} color={colorMap[status] || "default"} variant="contained" sx={{ fontSize: "0.7rem", height: "24px", borderRadius: "12px", fontWeight: "bold" }} />;
  };


  const rows = employeeOrders.orders?.response?.map((order, index) => ({
    id: `${order.id}-${order?.orderItems?.map((item) => item?.product?.id).join("-")}-${index}`,
    orderId: order.id,
    uniqueOrderId: order.orderId,
    orderDate: order.orderDate ? dayjs(order.orderData).format("DD MMM YYYY HH:mm") : "----",
    userName: order.user?.name || "----",
    userPhone: order.user?.phone || order.shippingAddress?.mobile
      || "----",
    userDetails: `${order.user?.name || ""} ( ${order.user?.email || ""} , ${order.user?.phone || order.shippingAddress?.mobile} )`,
    deliveryAddress: `${order.shippingAddress?.addressLine1 || ""},${order.shippingAddress?.city || ""}, ${order.shippingAddress?.state || ""}, ${order.shippingAddress?.zipcode || ""}, ${order.shippingAddress?.mobile || "----"}`,
    designerName: order?.orderItems?.map((item) => item?.product?.vendor?.name).join(", ") || "----",
    designerEmail: order?.orderItems?.map((item) => item?.product?.vendor?.email).join(", ") || "----",
    designerPhone: order?.orderItems?.map((item) => item?.product?.vendor?.phone).join(", ") || "----",
    designerDetails: `${order?.orderItems?.map((item) => item?.product?.vendor?.name).join(", ") || ""} ( ${order?.orderItems?.map((item) => item?.product?.vendor?.email).join(", ") || ""} , ${order?.orderItems?.map((item) => item?.product?.vendor?.phone).join(", ") || ""} )`,
    designerAddress: order?.orderItems?.map((item) => item?.product?.vendor?.fullAddress).join(", ") || "----",
    productTitle: order?.orderItems?.map((item) => item?.product?.title).join(", ") || "----",
    productImages: order?.orderItems
      ?.flatMap((item) =>
        (item?.product?.images || [])
          .filter((img) => img.isPrimary)
          .map((img) => img.fullUrl)
      )
      ?.filter(Boolean)
      ?.join(",") || "----",
    productName: order?.orderItems?.map((item) => item?.product?.productCategory?.name).join(", ") || "----",
    quantity: order?.orderItems?.map((item) => item?.quantity).join(", ") || 0,
    price: order?.orderItems?.map((item) => item?.orderPrice?.toFixed(2)).join(", ") || 0,
    color: order?.orderItems?.map((item) => item?.color).join(", ") || "----",
    size: order?.orderItems?.map((item) => item?.size).join(", ") || "----",
    totalQuantity: order?.totalItem || 0,
    totalPrice: order?.orderTotalPrice?.toFixed(2) || 0,
    cancelReturnDate: order.cancelDate ? dayjs(order.cancelDate).format("DD MMM YYYY") : order.returnDate ? dayjs(order.returnDate).format("DD MMM YYYY") : "----",
    cancelReturnReason: order.cancelRegion || order?.returnReason || "----",
    returnImages: order?.imageUrls,
    orderStatus: order.orderStatus === "PLACED" ? "ORDER ACCEPT" : order.orderStatus,
    deliveryDate: order.deliveryDate ? dayjs(order.deliveryDate).format("DD MMM YYYY") : "----",
    dispatchDate: order.dispatchDate ? dayjs(order.dispatchDate).format("DD MMM YYYY") : "----",
    deliveryDateHistories: order.deliveryDateHistories || [],
  })
  );

  const filteredRows = rows?.filter((row) => {
    const query = searchText.toLowerCase();
    return (
      row.uniqueOrderId?.toLowerCase().includes(query) ||
      row.userName?.toLowerCase().includes(query) ||
      row.userPhone?.toLowerCase().includes(query) ||
      row.deliveryAddress?.toLowerCase().includes(query) ||
      row.designerName?.toLowerCase().includes(query) ||
      row.designerEmail?.toLowerCase().includes(query) ||
      row.designerPhone?.toLowerCase().includes(query) ||
      row.productTitle?.toLowerCase().includes(query) ||
      row.productName?.toLowerCase().includes(query) ||
      String(row.quantity).toLowerCase().includes(query) ||
      String(row.price).toLowerCase().includes(query) ||
      String(row.totalQuantity).toLowerCase().includes(query) ||
      String(row.totalPrice).toLowerCase().includes(query) ||
      row.orderStatus?.toLowerCase().includes(query)
    );
  });

  const handleExportCSV = () => {
    const csvContent = filteredRows.map((row, index) => {
      return [
        index + 1,
        row.uniqueOrderId,
        row.orderDate,
        row.userName,
        row.userPhone,
        `"${row.deliveryAddress}"`,
        row.designerName,
        row.designerPhone,
        `"${row.productTitle}"`,
        `"${row.productName}"`,
        row.quantity,
        row.price,
        row.color,
        row.size,
        row.totalQuantity,
        row.totalPrice,
        row.orderStatus,
        row.deliveryDate,
        row.cancelDate,
        row.cancelRegion,
      ].join(',');
    }).join('\n');

    const headers = [
      'S.No.',
      'Order ID',
      'Order Date',
      'Customer Name',
      'Customer Phone',
      'Delivery Address',
      'Designer Name',
      'Designer Phone',
      'Product Title',
      'Product Name',
      'Quantity',
      'Price',
      'Color',
      'Size',
      'Total Quantity',
      'Total Price',
      'Order Status',
      'Delivery Date',
      'Cancel Date',
      'Cancel Reason',
    ].join(',');

    const csv = `${headers}\n${csvContent}`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'employee_orders.csv';
    link.click();
  };

  const handleExportPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: "a2", // even larger than A3 to fit all columns
    });

    doc.setFontSize(18);
    doc.text("EMployee Order List", 40, 30);

    const tableColumn = [
      'S.No.',
      'Order ID',
      'Order Date',
      'Customer Name',
      'Customer Phone',
      'Delivery Address',
      'Designer Name',
      'Designer Phone',
      'Product Title',
      'Product Name',
      'Quantity',
      'Price',
      'Color',
      'Size',
      'Total Quantity',
      'Total Price',
      'Order Status',
      'Delivery Date',
      'Cancel Date',
      'Cancel Reason',
    ];
    const tableRows = [];

    filteredRows.forEach((row, index) => {
      const orderData = [
        index + 1,
        row.uniqueOrderId,
        row.orderDate,
        row.userName,
        row.userPhone,
        `"${row.deliveryAddress}"`,
        row.designerName,
        row.designerPhone,
        `"${row.productTitle}"`,
        `"${row.productName}"`,
        row.quantity,
        row.price,
        row.color,
        row.size,
        row.totalQuantity,
        row.totalPrice,
        row.orderStatus,
        row.deliveryDate,
        row.cancelDate,
        row.cancelRegion,
      ];
      tableRows.push(orderData);
    });
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 50,
      styles: {
        fontSize: 8,
        cellPadding: 3,
        overflow: 'linebreak',
        valign: 'top',
      },
      columnStyles: {
        6: { cellWidth: 100 },   // Shipping Address
        13: { cellWidth: 100 },  // Product Titles
        14: { cellWidth: 100 },  // Product Names
      },
      headStyles: {
        fillColor: [37, 99, 235], // Tailwind blue-600 (RGB: 37,99,235)
        textColor: [255, 255, 255], // white text
        halign: 'left',
      },
      bodyStyles: {
        halign: 'left'
      },
      margin: { top: 50, left: 10, right: 10, bottom: 20 },
      didDrawPage: (data) => {
        doc.setFontSize(10);
        doc.text(`Generated on: ${new Date().toLocaleString()}`, 10, doc.internal.pageSize.height - 10);
      },
    });

    doc.save('employee_orders.pdf');
  };

  const columns = [
    {
      field: "serialNo",
      headerName: "S.No.",
      width: 60,
      sortable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1
    },
    { field: "uniqueOrderId", headerName: "Order ID", width: 130 },
    { field: "orderDate", headerName: "Order Date", width: 100, },
    { field: "userDetails", headerName: "Customer Details", width: 150 },
    { field: "deliveryAddress", headerName: "Shipping Address", width: 150 },
    { field: "designerDetails", headerName: "Vendor Details", width: 150 },
    { field: "designerAddress", headerName: "Vendor Address", width: 150 },
    { field: "dispatchDate", headerName: "Dispatch Date", width: 100 },

    { field: "productTitle", headerName: "Product Titles", width: 120 },
    {
      field: "productImages",
      headerName: "Image(s)",
      width: 100,
      renderCell: (params) => {
        const images = params?.value
          ? params.value.split(",").map((url) => url.trim()) // multiple comma separated
          : [];

        if (images.length === 0) {
          return <span>----</span>;
        }

        return (
          <div style={{ display: "flex", gap: "5px" }}>
            {images.map((url, index) => (
              <img
                key={index}
                onClick={() => {
                  setImageOpen(true);
                  setImageUrl(url);
                }}
                src={url || defaultImage}
                alt={`aadhaar_image_${index}`}
                width={30}
                height={30}
                style={{ borderRadius: 8, objectFit: "cover", cursor: "pointer" }}
              />
            ))}
          </div>
        );
      },
    },
    { field: "productName", headerName: "Product Names", width: 100 },
    { field: "color", headerName: "Color", width: 80 },
    { field: "size", headerName: "Size", width: 80 },
    { field: "quantity", headerName: "Quantity", width: 70 },
    { field: "price", headerName: "Price", width: 80 },
    { field: "totalQuantity", headerName: "Total Quantity", width: 80 },
    { field: "totalPrice", headerName: "Total Price", width: 80 },
    { field: "cancelReturnDate", headerName: "Cancel/Return Date", width: 100, },
    { field: "cancelReturnReason", headerName: "Cancel/Return Reason", width: 100 },
    {
      field: "returnImages",
      headerName: "Return Image(s)",
      width: 100,
      renderCell: (params) => {
        const images = params?.value

        if (images.length === 0) {
          return <span>----</span>;
        }

        return (
          <div style={{ display: "flex", gap: "5px" }}>
            {images.map((url, index) => (
              <img
                key={index}
                onClick={() => {
                  setImageOpen(true);
                  setImageUrl(url);
                }}
                src={url || defaultImage}
                alt={`aadhaar_image_${index}`}
                width={30}
                height={30}
                style={{ borderRadius: 8, objectFit: "cover", cursor: "pointer" }}
              />
            ))}
          </div>
        );
      },
    },
    {
      field: "orderStatus",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        const statusFlow = ["SHIPPED", "DELIVERED", "RETURNED", "PICKED_UP", "COMPLETED"];
        const currentStatusIndex = statusFlow.indexOf(params.row.orderStatus);

        // Next status only
        const nextStatus = statusFlow[currentStatusIndex + 1];

        return (
          <Box display="flex" alignItems="center">
            {getStatusChip(params.row.orderStatus)}
            <IconButton
              size="small"
              onClick={(event) => handleMenuClick(event, params.row.id)}
              disabled={
                params.row.orderStatus === "DELIVERED" ||
                params.row.orderStatus === "CANCELLED" ||
                params.row.orderStatus === "COMPLETED"
              }
            >
              <EditIcon fontSize="small" />
            </IconButton>

            {selectedIndex === params.row.id && nextStatus && (
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
              >
                <MenuItem onClick={() => handleConfirmOpen(params.row.orderId, nextStatus)}>
                  {nextStatus} ORDER
                </MenuItem>
              </Menu>
            )}
          </Box>
        );
      }
    },
    {
      field: "deliveryDate",
      headerName: "Delivery Date",
      width: 120,
      renderCell: (params) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box display="flex" alignItems="center" position="relative">
            <span>{params.value}</span>
            <IconButton
              size="small"
              onClick={() => {
                toggleCalendar(params.row.id, params.row.orderId);
                setSelectedDate(params.value ? dayjs(params.value) : null);
              }}
              disabled={
                params.row.orderStatus === "DELIVERED" ||
                params.row.orderStatus === "CANCELLED"
              }
            >
              <CalendarTodayIcon fontSize="small" />
            </IconButton>

            {openCalendars[params.row.id] && (
              <Box sx={{ position: "absolute", top: "100%", left: 0, zIndex: 1500 }}>
                <DatePicker
                  value={selectedDate}
                  onChange={(newDate) => {
                    if (newDate) {
                      setSelectedDate(newDate);
                      setConfirmationOpen(true);
                    }
                  }}
                  disablePast
                  onClose={() =>
                    toggleCalendar(params.row.id, params.row.orderId, true)
                  }
                  slotProps={{
                    textField: { size: "small", sx: { display: "none" } },
                  }}
                  PopperProps={{
                    placement: "bottom-start",
                    disablePortal: true, // 👈 fix for opening inside row
                  }}
                  open
                />
              </Box>
            )}
          </Box>
        </LocalizationProvider>
      )
    }
    ,
    {
      field: "history",
      headerName: "History",
      width: 70,
      renderCell: (params) => (
        <Tooltip title="View History">
          <IconButton
            size="small"
            sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
            onClick={() => {
              setOpenDateHistoryModal(true);
              setOrder(params.row);
            }}
          >
            <Visibility fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
          </IconButton>
        </Tooltip>
      )
    }
  ];

  const excludedFields = ['serialNo', 'history']; // Add more fields if needed

  const exportableColumns = columns.filter(col => !excludedFields.includes(col.field));
  // Get headers from column definitions
  const headers = exportableColumns.map(col => col.headerName);
  const csvFields = exportableColumns.map(col => col.field);

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const data = filteredRows.map(row =>
      csvFields.map(field => row[field] ?? "----")
    );

    const html = `
      <html>
        <head>
          <title>Employee Order List</title>
          <style>
            @media print {
              @page { size: A3 landscape; }
            }
            body {
              font-family: Arial, sans-serif;
              font-size: 12px;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              table-layout: auto;
            }
            th, td {
              border: 1px solid #999;
              padding: 4px;
              text-align: left;
              white-space: pre-wrap;
              word-break: break-word;
            }
            th {
             background: #449AEF;
                color: white;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            tr:nth-child(even) {
              background: #f5f5f5;
            }
          </style>
        </head>
        <body>
          <h2>Employee Order List</h2>
          <table>
            <thead>
              <tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr>
            </thead>
            <tbody>
              ${data.map(row => `<tr>${row.map(cell => `<td>${cell}</td>`).join('')}</tr>`).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
      }, 300);
    };
  };

  return (
    <div >
      <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
        <CardHeader
          title={
            <Typography variant="h6" className="text-gray-700">
              ACCEPTED ORDERS
            </Typography>
          }
        />
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', mb: 2 }}>
            <Box sx={{ display: 'flex', gap: 1.5, mb: { xs: 2, sm: 0 } }}>
              <Button
                variant="contained"
                startIcon={<FileDownload />}
                onClick={handleExportCSV}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Export CSV
              </Button>
              <Button
                variant="contained"
                startIcon={<PictureAsPdf />}
                onClick={handleExportPDF}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Export PDF
              </Button>
              <Button
                variant="contained"
                startIcon={<Print />}
                onClick={handlePrint}
                sx={{
                  background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  borderRadius: '6px',
                  px: 2,
                  py: 0.8,
                  transition: 'all 0.2s',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                    transform: 'scale(1.02)',
                  },
                  cursor: 'pointer',
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                Print
              </Button>
            </Box>
            <Box>
              <TextField
                label="Search Orders"
                variant="outlined"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ width: { xs: '100%', sm: '300px' } }}
              />
            </Box>
          </Box>
          <Box sx={{ height: "100%", width: "100%" }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pagination
              initialState={{
                pagination: { paginationModel: { pageSize: 10, page: 0 } },
              }}
              pageSizeOptions={[10, 25, 50, 75, 100]}
              getRowId={(row) => row.id}
              disableSelectionOnClick
              density="compact"
              experimentalFeatures={{ virtualization: true }}
              loading={employeeOrders.loading}
              autoHeight={true}
              sx={{
                borderRadius: 2,
                fontSize: "0.8rem",
                "& .MuiDataGrid-cell": {
                  fontSize: "0.8rem",
                  border: "1px solid rgb(204, 201, 201)",
                  minHeight: "36px !important",
                  height: "36px !important",
                  lineHeight: "1.2",
                  paddingTop: "4px",
                  paddingBottom: "4px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "#449AEF",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "0.8rem",
                  padding: "8px",
                  border: "1px solid rgb(204, 201, 201)",
                  minHeight: "36px !important",
                  height: "36px !important",
                  lineHeight: "1.2",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontSize: "0.8rem",
                  fontWeight: 600,
                },
                "& .MuiDataGrid-row": {
                  maxHeight: "36px !important",
                  minHeight: "36px !important",
                },
                "& .MuiDataGrid-row:nth-of-type(odd)": {
                  backgroundColor: "#f5f5f5",
                },
                "& .MuiDataGrid-row:nth-of-type(even)": {
                  backgroundColor: "#ffffff",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            />
          </Box>
        </CardContent>
      </Card>

      {/* Confirmation Dialog for order status */}
      {confirmOpen && (
        <Dialog
          open={confirmOpen}
          onClose={() => setConfirmOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Confirm Order Status Change</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to change the order status to{" "}
              <strong>{selectedStatus}</strong>?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmOpen(false)} color="secondary">
              Cancel
            </Button>
            <Button
              onClick={handleStatusChange}
              color="primary"
              variant="contained"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Confirmation Dialog for date changed*/}
      {confirmationOpen && (
        <Dialog
          open={confirmationOpen}
          fullWidth
          maxWidth="sm"
          onClose={() => setConfirmationOpen(false)}
        >
          <DialogTitle>Conformation for Changed Date</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to select{" "}
              <strong>
                {selectedDate
                  ? selectedDate.format("DD MMM YYYY")
                  : "this date"}
              </strong>
              ?
            </Typography>
            <TextField
              label="Reason for Changed Date ?"
              variant="outlined"
              fullWidth
              margin="dense"
              autoFocus
              value={region}
              onChange={(e) => setRegion(e.target.value)}
            />
          </DialogContent>

          <DialogActions sx={{ padding: "16px" }}>
            <Button
              onClick={() => {
                setConfirmationOpen(false);
                setSelectedDate(null);
                setSelectedOrderId(null);
                setRegion("");
              }}
              color="secondary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (region.trim() !== "" && selectedDate && selectedOrderId) {
                  handleDateChange(selectedDate, selectedOrderId, region);
                  setConfirmationOpen(false);
                }
              }}
              variant="contained"
              color="primary"
              disabled={!region.trim()}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* View Orders Delivery Date History Modal */}
      {openDateHistoryModal && (
        <Modal
          open={openDateHistoryModal}
          onClose={() => setOpenDateHistoryModal(false)}
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            borderRadius: '12px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
            p: 3,
            width: { xs: '95%', sm: '80%', md: '70%' },
            maxWidth: '800px',
            maxHeight: '90vh',
            overflow: 'auto',
            fontSize: "0.8rem",
          }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} pb={1} sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: "1.1rem" }}>
                Date History
              </Typography>
              <IconButton onClick={() => setOpenDateHistoryModal(false)} size="small">
                <CloseIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
            <Paper sx={{ height: 300, width: "100%", boxShadow: 0, borderRadius: 0 }}>
              <DataGrid
                rows={
                  order?.deliveryDateHistories?.map((history, index) => ({
                    id: index,
                    oldDate: history.oldDeliveryDate,
                    newDate: history.newDeliveryDate,
                    reason: history.region || "----"
                  })) || []
                }
                columns={[
                  { field: "oldDate", headerName: "Old Date", flex: 1, renderCell: (params) => params.value ? dayjs(params?.value).format("DD MMM YYYY") : "----", },
                  { field: "newDate", headerName: "New Date", flex: 1, renderCell: (params) => params.value ? dayjs(params?.value).format("DD MMM YYYY") : "----", },
                  { field: "reason", headerName: "Reason", flex: 2 },
                ]}
                pagination
                initialState={{
                  pagination: { paginationModel: { pageSize: 5, page: 0 } },
                }}
                pageSizeOptions={[5, 10, 15]}
                disableSelectionOnClick
                density="compact"
                experimentalFeatures={{ virtualization: true }}
                loading={employeeOrders.loading}
                autoHeight={true}
                sx={{
                  borderRadius: 2,
                  fontSize: "0.8rem",
                  "& .MuiDataGrid-cell": {
                    fontSize: "0.8rem",
                    border: "1px solid rgb(204, 201, 201)",
                    minHeight: "36px !important",
                    height: "36px !important",
                    lineHeight: "1.2",
                    paddingTop: "4px",
                    paddingBottom: "4px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    backgroundColor: "#449AEF",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "0.8rem",
                    padding: "8px",
                    border: "1px solid rgb(204, 201, 201)",
                    minHeight: "36px !important",
                    height: "36px !important",
                    lineHeight: "1.2",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontSize: "0.8rem",
                    fontWeight: 600,
                  },
                  "& .MuiDataGrid-row": {
                    maxHeight: "36px !important",
                    minHeight: "36px !important",
                  },
                  "& .MuiDataGrid-row:nth-of-type(odd)": {
                    backgroundColor: "#f5f5f5",
                  },
                  "& .MuiDataGrid-row:nth-of-type(even)": {
                    backgroundColor: "#ffffff",
                  },
                  "& .MuiDataGrid-row:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                  height: 300,
                }}
              />
            </Paper>
          </Box>
        </Modal>
      )}
      {/* Common Popup */}
      <ImagePopup
        open={imageOpen}
        onClose={() => setImageOpen(false)}
        imageUrl={imageUrl}
      />
    </div>
  );
}
export default Orders;
